export const NONE = '';
export const FRONTEND_PRODUCT_CART = 'frontend_product.cart';
export const FRONTEND_PRODUCT_BLOCK_AUX = 'frontend_product.block_aux';

export const control_options = [{
	label: 'Нет',
	value: NONE,
},{
	label: 'Рядом с кнопкой "В корзину"',
	value: FRONTEND_PRODUCT_CART,
},{
	label: 'Блок дополнительной информации в боковой части страницы.',
	value: FRONTEND_PRODUCT_BLOCK_AUX,
}];